module.exports = __webpack_public_path__ + "files/ae18f04c25326592e0a2b59da53b9c2a.png";